import type { CreativeEffectOptions, Swiper } from 'swiper'
import type { MousewheelOptions } from 'swiper/types'

export const STORY_CREATIVE_EFFECT: CreativeEffectOptions = {
	limitProgress: 2,
	perspective: false,
	prev: { translate: [0, 0, 0], opacity: 0 },
	next: { translate: [0, '4.4642857%', 0], scale: 0.95 },
}

export const STORY_WHEEL_OPTIONS: MousewheelOptions = {
	enabled: true,
	forceToAxis: true,
	releaseOnEdges: true,
	thresholdTime: 300,
}

export const syncStorySlideMask = (swiper: Swiper) => {
	for (const slide of swiper.slides) {
		const progress = Math.max(0, Math.min(-slide.progress, 1))
		slide.style.setProperty('--story-mask-opacity', String(progress * 0.5))
	}
}
